import { Input as OriginalInput } from 'antd';
import { withWrap } from '../../utils/hoc';
const { Group: OriginalGroup, TextArea: OriginalTextArea, Password: OriginalPassword, Search: OriginalSearch, } = OriginalInput;
const Input = withWrap(OriginalInput);
Input.Group = OriginalGroup;
Input.TextArea = withWrap(OriginalTextArea);
Input.Password = withWrap(OriginalPassword);
Input.Search = withWrap(OriginalSearch);
export default Input;
